// extracted by mini-css-extract-plugin
export default {"uploader":"styles_uploader__HPhQo"};